// extracted by mini-css-extract-plugin
module.exports = {"footerLeft":"footer-left_footerLeft__2Hero","imgBox":"footer-left_imgBox__FH6MO","songDetails":"footer-left_songDetails__2IKI2"};